import React from "react";
import data from "../../json/ProjectManagement/herosection.json";

const Herosection = () => {
  return (
    <div className="w-full flex justify-center projecthero">
      <div className="2xl:container p-4 lg:px-20 flex justify-center">
        <div className="text-center w-full md:w-5/6 lg:w-10/12 flex flex-col items-center text-white py-[30px] md:py-[60px] lg:py-[120px]">
          <h1 className="text-28 md:text-40 lg:text-64">{data.Title}</h1>
          <p className="text-14 lg:text-base mt-4">{data.para}</p>
          {/* <div className="mt-12">
            <button className="bg-btnbg text-white px-7 py-3 lg:px-14 lg:py-6 text-base font-semibold rounded-[16px]">
              Learn More
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Herosection;
